import qs from 'qs';
import { useMutation } from '../../../ReactQuery';
import { get, put, remove } from '../../../redux/api';
import { nuc } from '../../../utils';
import Locator from '../../../../shared/Locator';
import type { UpdateProjectCorrectionRequest } from '../../../../typings/api';

/**
 * Helpers for upserting and deleting project corrections.
 *
 * When deleting a project correction you can optionally provide the locator of a user revision that imports the
 * corrected component. Doing so will queue an issue scan of the user revision.
 */
export default function useProjectCorrection(revisionLocator: string, parentRevisionLocator?: string) {
  const projectLocator = new Locator(revisionLocator).toPackageString();

  const upsertCorrection = useMutation({
    mutationFn: ({ project, licenses, noticeFiles }: UpdateProjectCorrectionRequest) => {
      const url = `/api/projects/${nuc(projectLocator)}/correction`;
      return put(url, { project, licenses, noticeFiles, parentRevisionLocator });
    },
  });

  const deleteCorrection = useMutation({
    mutationFn: () => {
      const queryString = qs.stringify({
        parentRevisionLocator: parentRevisionLocator ? nuc(parentRevisionLocator) : undefined,
      });
      const url = `/api/projects/${nuc(projectLocator)}/correction?${queryString}`;
      return remove(url);
    },
  });

  const rebuild = useMutation({
    mutationFn: () => {
      const url = `/api/revisions/${nuc(revisionLocator)}/rebuild`;
      return get(url);
    },
  });

  return { upsertCorrection, deleteCorrection, rebuild };
}
